module.exports = __webpack_public_path__ + "img/greg-bulla-1407473-unsplash.36781f12.jpg";